export default __webpack_public_path__ + "static/media/gel-nails.9ebf8aab.jpg";